/**
 * ワークスペース Hooks スキーマ — Claude Code Hooks 互換
 */
import { z } from 'zod';
// ========================================
// イベント種別
// ========================================
/**
 * フックイベント種別（13種 — Claude Code Hooks 互換）
 *
 * 公式イベントとの対応:
 * - SessionStart: セッション（タスク）開始時
 * - UserPromptSubmit: プロンプト送信時（処理開始前）
 * - Stop: Claude の応答完了時（ターンごと）
 * - StopFailure: API エラーでターンが終了した時
 * - PreToolUse / PostToolUse / PostToolUseFailure: ツール実行前後
 * - SubagentStart / SubagentStop: サブエージェントの開始・終了
 * - PreCompact / PostCompact: コンテキスト圧縮の前後
 * - ApprovalRequired: ツール承認待ちに入る時（ユーザーの承認判断を待機開始）
 *   matcherValue: 承認対象のツール名
 * - UserInputRequired: 質問回答待ちに入る時（askUserInput / askConfirmation の開始）
 *   matcherValue: 'userInput' | 'confirmation'
 */
export const HookEventTypeSchema = z.enum([
    'SessionStart',
    'UserPromptSubmit',
    'PreToolUse',
    'PostToolUse',
    'PostToolUseFailure',
    'Stop',
    'StopFailure',
    'SubagentStart',
    'SubagentStop',
    'PreCompact',
    'PostCompact',
    'ApprovalRequired',
    'UserInputRequired',
]);
/** 全イベント種別の配列 */
export const HOOK_EVENT_TYPES = HookEventTypeSchema.options;
// ========================================
// フック定義
// ========================================
/**
 * フック定義（Claude Code hooks.json 互換）
 */
export const HookDefinitionSchema = z.object({
    type: z.literal('command'),
    command: z.string().min(1, 'command is required'),
    timeout: z.number().optional(),
    enabled: z.boolean().default(true),
});
// ========================================
// フックグループ
// ========================================
/**
 * フックグループ（マッチャー付き）
 */
export const HookGroupSchema = z.object({
    matcher: z.string().optional(),
    hooks: z.array(HookDefinitionSchema).min(1, 'hooks must have at least one entry'),
});
// ========================================
// ワークスペースフック設定
// ========================================
/**
 * ワークスペースフック設定（hooks.json 互換構造）
 *
 * イベント種別をキーとする HookGroup 配列のマップ。
 * z.record + HookEventTypeSchema で不正なイベント種別を拒否する。
 */
export const WorkspaceHooksSchema = z.record(HookEventTypeSchema, z.array(HookGroupSchema));
//# sourceMappingURL=workspace-hooks-schemas.js.map